/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import 'react-drawer/lib/react-drawer.css';

import { useDispatch, useSelector, connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

// Reactstrap
import {
  Button,
  Offcanvas,
  OffcanvasBody,
  Input,
} from 'reactstrap';

// Import menuDropdown
import { useTranslation, withTranslation } from 'react-i18next';
import ProfileMenu from '../CommonForBoth/TopbarDropdown/ProfileMenu';
import LanguageDropdown from '../CommonForBoth/TopbarDropdown/LanguageDropdown';
import ZebraDropdown from '../CommonForBoth/TopbarDropdown/ZebraDropdown';

import softwareLogo from '../../assets/images/Glossy blue balloon pArTy logo.png';

// Redux Store
import {
  toggleRightSidebar,
  changeSidebarType,
  changeLayoutMode,
} from '../../store/actions';
import { layoutModeTypes } from '../../constants/layout';

import UserLists from '../User/UserLists';
import { useScanner } from '../../utilities/ScannerContext';
import { Can } from '../../utilities/Can';

function Header({ toggleMenuCallback }) {
  const [isSearch, setIsSearch] = useState(false);
  const [itemListsOpen, setItemListsOpen] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const returnsSearchRef = useRef(null);
  const {
    isConnected, connectScanner, reconnectScanner, destroyReader,
    registerDefaultListener, supported, busy,
  } = useScanner();
  const hasScanner = isConnected();

  useEffect(() => {
    reconnectScanner();
  }, [reconnectScanner]);

  useEffect(() => registerDefaultListener((label) => {
    const path = document.activeElement === returnsSearchRef.current
      ? '/customer-service/returns' : '/search';
    history.push(`${path}?q=${encodeURIComponent(label)}`);
  }), [history, registerDefaultListener]);

  const leftSideBarType = useSelector((state) => state.Layout.leftSideBarType);
  const layoutModeType = useSelector((state) => state.Layout.layoutModeType);

  const toggleMenu = () => {
    const isMobileViewport = window.innerWidth <= 998;

    if (isMobileViewport) {
      if (toggleMenuCallback) {
        toggleMenuCallback();
      }
      return;
    }

    if (leftSideBarType === 'default' || leftSideBarType === 'compact') {
      dispatch(changeSidebarType('icon', false));
    } else {
      dispatch(changeSidebarType('default', false));
    }
  };

  const toggleItemListsOpen = () => {
    setItemListsOpen(!itemListsOpen);
  };

  const toggleTopCanvas = () => {
    setItemListsOpen(!itemListsOpen);
  };

  const toggleLayoutMode = () => {
    dispatch(changeLayoutMode(
      layoutModeType === layoutModeTypes.DARK
        ? layoutModeTypes.LIGHT
        : layoutModeTypes.DARK,
    ));
  };

  return (
    <header id="page-topbar">
      <div className="navbar-header">
        <div className="d-flex">
          <div className="navbar-brand-box">
            <Link to="/" className="logo software-logo-link" aria-label={t('Home')}>
              <span className="logo-sm">
                <img className="software-logo-image" src={softwareLogo} alt="" />
              </span>
              <span className="logo-lg">
                <img className="software-logo-image" src={softwareLogo} alt="" />
              </span>
            </Link>
          </div>

          <button
            type="button"
            onClick={toggleMenu}
            className="btn btn-sm px-3 font-size-16 header-item"
            id="vertical-menu-btn"
          >
            <i className="fa fa-fw fa-bars" />
          </button>

          <form
            onSubmit={(e) => {
              e.preventDefault();

              history.push(`/search?q=${encodeURIComponent(e.target.q.value)}`);
            }}
            className="app-search d-none d-lg-block"
          >
            <div className="position-relative">
              <input
                type="text"
                name="q"
                className="form-control"
                placeholder={`${t('Search')}...`}
              />
              <span className="bx bx-search-alt" />
            </div>
          </form>
          <Can i="see" this="Customer Service">
            <form
              className="app-search d-none d-lg-block ms-2"
              role="search"
              aria-label={t('Search returns')}
              onSubmit={(event) => {
                event.preventDefault();
                const tracking = returnsSearchRef.current.value.trim();
                if (tracking) {
                  history.push(`/customer-service/returns?q=${encodeURIComponent(tracking)}`);
                }
              }}
            >
              <div className="position-relative">
                <input
                  ref={returnsSearchRef}
                  type="text"
                  name="tracking"
                  className="form-control"
                  aria-label={t('Search returns by tracking number')}
                  placeholder={t('Return tracking number')}
                  autoComplete="off"
                  spellCheck={false}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>
          </Can>
        </div>
        <div className="d-flex">
          <div className="d-flex align-items-center px-2">
            <div className="form-check form-switch mb-0 d-flex align-items-center gap-2">
              <Input
                type="switch"
                role="switch"
                id="theme-mode-switch"
                checked={layoutModeType === layoutModeTypes.DARK}
                onChange={toggleLayoutMode}
              />
              <label className="form-check-label small text-muted mb-0" htmlFor="theme-mode-switch">
                {layoutModeType === layoutModeTypes.DARK ? t('Dark') : t('Light')}
              </label>
            </div>
          </div>
          <button
            type="button"
            className={`btn btn-sm px-3 font-size-16 header-item text-${hasScanner ? 'success' : 'muted'}`}
            disabled={!supported || busy}
            onClick={() => (hasScanner ? destroyReader() : connectScanner())}
            title={supported
              ? t(hasScanner ? 'Disconnect Barcode Scanner' : 'Connect Barcode Scanner')
              : t('Scanner connections are unavailable in this browser')}
            aria-label={t(hasScanner ? 'Disconnect Barcode Scanner' : 'Connect Barcode Scanner')}
            aria-pressed={hasScanner}
          >
            <i className={`mdi ${hasScanner ? 'mdi-barcode' : 'mdi-barcode-off'}`} />
          </button>
          <ZebraDropdown />
          <LanguageDropdown />

          <div>
            <Button
              type="button"
              color="default"
              className="btn header-item noti-icon waves-effect"
              id="page-header-user-dropdown"
              onClick={toggleItemListsOpen}
            >
              <i className="mdi mdi-view-list" />
            </Button>
          </div>

          <div className="dropdown d-inline-block d-lg-none ms-2">
            <button
              onClick={() => setIsSearch(!isSearch)}
              type="button"
              className="btn header-item noti-icon"
              id="page-header-search-dropdown"
            >
              <i className="mdi mdi-magnify" />
            </button>
            <div
              className={`dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 ${
                isSearch ? 'show' : ''
              }`}
              aria-labelledby="page-header-search-dropdown"
            >
              <form className="p-3">
                <div className="form-group m-0">
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search anything..."
                    />
                    <div className="input-group-append">
                      <button className="btn btn-primary" type="submit">
                        <i className="mdi mdi-magnify" />
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <ProfileMenu />
        </div>
      </div>

      <Offcanvas
        isOpen={itemListsOpen}
        direction="top"
        className="user-lists-offcanvas"
        scrollable
        style={{ height: '95%' }}
        toggle={toggleTopCanvas}
      >
        <OffcanvasBody className="user-lists-offcanvas-body pt-0 pb-0">
          <UserLists />
        </OffcanvasBody>
      </Offcanvas>
    </header>
  );
}

Header.propTypes = {
  toggleMenuCallback: PropTypes.func,
};

const mapStateToProps = (state) => ({ ...state.Layout });

export default connect(mapStateToProps, {
  toggleRightSidebar,
  changeSidebarType,
  changeLayoutMode,
})(withTranslation()(Header));
